export default {
    namespaced: true,
    state: {
        modules: [],
        widgets: []
    }
};
